import { createContext, useContext, useState, useRef } from "react";

const FullscreenContext = createContext();

export const FullscreenProvider = ({ children }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const tableRef = useRef(null);

    const toggleFullScreen = () => {
        // console.log("helloo")
        if (!document.fullscreenElement) {
            tableRef.current?.requestFullscreen().then(() => setIsFullScreen(true));
        } else {
            document.exitFullscreen().then(() => setIsFullScreen(false));
        }
    };

    return (
        <FullscreenContext.Provider value={{ isFullScreen, toggleFullScreen, tableRef }}>
            {children}
        </FullscreenContext.Provider>
    );
};

export const useFullscreen = () => useContext(FullscreenContext);
